import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SwiperModule } from 'swiper/angular';
import { RefresherComponent } from './refresher/refresher.component';
import { ScrollerComponent } from './scroller/scroller.component';
import { LightboxGalleryComponent } from './lightbox-gallery/lightbox-gallery.component';
import { SearchPopoverComponent } from './search-popover/search-popover.component';
import { MessagePopoverComponent } from './message-popover/message-popover.component';
import { AppNavBarComponent } from './app-nav-bar/app-nav-bar.component';
import { ReportPopoverComponent } from './report-popover/report-popover.component';
import { AuthModalComponent } from './auth-modal/auth-modal.component';
import { SigninPopoverComponent } from './signin-popover/signin-popover.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SwiperModule
  ],
  declarations: [
    RefresherComponent,
    ScrollerComponent,
    LightboxGalleryComponent,
    SearchPopoverComponent,
    SigninPopoverComponent,
    MessagePopoverComponent,
    AppNavBarComponent,
    ReportPopoverComponent,
    AuthModalComponent
  ],
  exports: [
    RefresherComponent,
    ScrollerComponent,
    LightboxGalleryComponent,
    SearchPopoverComponent,
    SigninPopoverComponent,
    MessagePopoverComponent,
    AppNavBarComponent,
    ReportPopoverComponent,
    AuthModalComponent
  ]
})
export class ComponentsModule {}
